var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Form, Formik } from 'formik';
import React, { useContext, useMemo } from 'react';
import { createValidatorForFields } from './formFieldsFromSettings';
import SignupProvider, { SignupContext, SignupFormikContext, } from './signup-context';
import { useSignupSubmit } from './signupSubmit';
// Get the default values from the lookupData results if there are any,
// otherwise default them to an empty string
function getFieldDefaultValues(fields, lookupData) {
    const values = {};
    if (lookupData) {
        fields.forEach((field) => {
            var _a;
            values[field.name] = (_a = lookupData === null || lookupData === void 0 ? void 0 : lookupData[field.name]) === null || _a === void 0 ? void 0 : _a.masked;
        });
    }
    else {
        fields.forEach((field) => {
            values[field.name] = '';
        });
    }
    return values;
}
function formatLookupData(signupValues, lookupData) {
    if (!lookupData) {
        return signupValues;
    }
    const values = Object.assign({ externalId: String(lookupData === null || lookupData === void 0 ? void 0 : lookupData.externalId) }, signupValues);
    Object.keys(values).forEach((key) => {
        var _a, _b;
        if (values[key] === ((_a = lookupData[key]) === null || _a === void 0 ? void 0 : _a.masked)) {
            values[key] = (_b = lookupData[key]) === null || _b === void 0 ? void 0 : _b.encrypted;
        }
    });
    return values;
}
function SignupForm(props) {
    // Available using Voyado integration.
    const lookupData = props === null || props === void 0 ? void 0 : props.lookupData;
    const { allFields, selectedCountry } = useContext(SignupContext);
    // Create the Formik validator for all fields
    const validate = createValidatorForFields(allFields);
    // Handle the submit mutation
    const signupSubmit = useSignupSubmit();
    // Get the initial values for the form
    const initialValues = useMemo(() => {
        return Object.assign(Object.assign({}, getFieldDefaultValues(allFields, lookupData)), { country: selectedCountry.code });
    }, [allFields, lookupData, selectedCountry.code]);
    return (React.createElement(Formik, { enableReinitialize: true, validateOnChange: true, onSubmit: (values, actions) => {
            signupSubmit({
                values: formatLookupData(values, props.lookupData),
                actions,
            });
        }, validate: validate, initialValues: initialValues }, (formik) => props.children({ formik })));
}
// This needs to be done to provide the context to the form
function SignupFormProvider(_a) {
    var { LoadingComponent } = _a, props = __rest(_a, ["LoadingComponent"]);
    return (React.createElement(SignupProvider, { LoadingComponent: LoadingComponent },
        React.createElement(SignupForm, Object.assign({}, props), ({ formik }) => (React.createElement(Form, null,
            React.createElement(SignupFormikContext.Provider, Object.assign({ value: { formik } }, props)))))));
}
export default SignupFormProvider;
//# sourceMappingURL=SignupFormContainer.js.map